import { render, staticRenderFns } from "./WsDataTablePagenateTypeA.vue?vue&type=template&id=40c7f079&"
import script from "./WsDataTablePagenateTypeA.vue?vue&type=script&lang=js&"
export * from "./WsDataTablePagenateTypeA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports